import script from "./EditarReservaView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarReservaView.vue?vue&type=script&setup=true&lang=js"

import "./EditarReservaView.vue?vue&type=style&index=0&id=7ea6d71a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea6d71a"]])

export default __exports__